module.exports = __webpack_public_path__ + "images/stickers/pete-broken@2x.6c728b6e7a9e05e80050.png";